<template>
  <div ref="app">
    <div class="class_name">
      {{ schoolInfo.gradeName }}{{ schoolInfo.title }}
    </div>
    <div class="school_name">{{ schoolInfo.schoolName }}</div>
    <div class="prompt">家长你好，请绑定您的孩子信息</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="家长姓名" prop="name">
        <el-input
          maxlength="20"
          v-model="ruleForm.name"
          placeholder="请输入真实姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="家长手机号" prop="mobile">
        <el-input
          maxlength="11"
          v-model="ruleForm.mobile"
          placeholder="请输入正确手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="家长角色" prop="relation">
        <el-select
          v-model="ruleForm.relation"
          style="width: 100%"
          placeholder="请选择家长角色"
        >
          <el-option
            v-for="item in relationList"
            :key="item"
            :value="item"
            :label="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学生姓名">
        <el-input
          maxlength="20"
          v-model="studentName"
          placeholder="请填写学生的真实姓名"
          ><el-button
            type="success"
            slot="append"
            style="font-size: 0.32rem"
            @click="queryByName"
            >查找孩子</el-button
          ></el-input
        >
      </el-form-item>
    </el-form>
    <div
      class="studentItem"
      v-for="item in studentList"
      :key="item.id"
      @click="nowStudent = item.id"
    >
      <div style="flex: 1">
        {{ item.name
        }}<span v-if="item.sex">({{ item.sex == 0 ? '男' : '女' }})</span>
      </div>
      <div style="flex: 1">
        {{ item.birth ? item.birth : '' }}
      </div>
      <div class="check-box" :class="nowStudent == item.id ? 'active' : ''">
        <transition name="el-fade-in">
          <img
            src="../assets/img/check.png"
            class="check-img"
            v-show="nowStudent == item.id"
          />
        </transition>
      </div>
    </div>
    <div class="sub_btn" @click="bindParent">绑 定 孩 子</div>
  </div>
</template>
<script>
import '../assets/css/bind.css'
import { queryByName, getById, bindParent } from '@/api/home'
export default {
  data() {
    return {
      classId: '',
      schoolInfo: {
        gradeName: '',
        title: '',
        schoolId: '',
        schoolName: ''
      },
      ruleForm: {
        mobile: '',
        name: '',
        relation: '',
        studentId: ''
      },
      rules: {
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入真实姓名',
            trigger: 'blur'
          }
        ],
        relation: [
          {
            required: true,
            message: '请选择家长角色',
            trigger: 'blur'
          }
        ]
      },
      relationList: ['爸爸', '妈妈', '爷爷', '奶奶', '外公', '外婆', '其他'],
      studentName: '',
      studentList: [],
      nowStudent: ''
    }
  },
  created() {},
  methods: {
    bindParent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (!this.nowStudent) return this.$message.error('请选择学生')
          let params = this.ruleForm
          params.schoolId = this.schoolInfo.schoolId
          params.studentId = this.nowStudent
          bindParent(params).then(res => {
            if (res.data.code == 0) {
              const index = this.studentList.findIndex(item => {
                return this.nowStudent == item.id
              })
              this.$router.push({
                path: '/bindState',
                query: {
                  code: 0,
                  className: this.schoolInfo.gradeName + this.schoolInfo.title,
                  studentInfo: this.studentList[index].birth
                    ? this.studentList[index].name +
                      '(' +
                      this.studentList[index].birth +
                      ')'
                    : this.studentList[index].name,
                  schoolId: this.schoolInfo.schoolId,
                  schoolName: this.schoolInfo.schoolName,
                  gradeId: this.schoolInfo.gradeId,
                  classesId: this.classId
                }
              })
            }
          })
        }
      })
    },
    getById() {
      const params = {
        id: this.classId
      }
      getById(params).then(res => {
        if (res.data.code == 0) {
          this.schoolInfo = res.data.data
        }
      })
    },
    queryByName() {
      const params = {
        schoolId: this.schoolInfo.schoolId,
        gradeId: this.schoolInfo.gradeId,
        classesId: this.schoolInfo.id,
        name: this.studentName,
        curPage: 1,
        pageSize: 10
      }
      queryByName(params).then(res => {
        if (res.data.code == 0) {
          this.nowStudent = ''
          this.studentList = res.data.data.dataList
        }
      })
    }
  },
  mounted() {
    this.classId = this.$route.query.classesId
    this.getById()
  }
}
</script>
<style scoped>
#app {
  width: 100vw;
  height: 100vh;
  padding: 0.53rem 0.27rem 1.6rem 0.27rem;
  box-sizing: border-box;
}
.class_name {
  font-size: 0.48rem !important;
  color: #333;
  font-weight: 700;
  text-align: center;
  margin-bottom: 0.27rem;
}
.school_name {
  font-size: 0.43rem !important;
  color: #333;
  text-align: center;
  margin-bottom: 0.27rem;
}
.prompt {
  font-size: 0.43rem !important;
  color: #333;
  text-align: center;
  margin-bottom: 0.27rem;
}
.sub_btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.6rem;
  background-color: #07c160;
  color: #fff;
  font-size: 0.43rem !important;
  text-align: center;
  line-height: 1.6rem;
}
.studentItem {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 0.266667rem 0.426667rem;
  overflow: hidden;
  color: #323233;
  font-size: 0.373333rem !important;
  line-height: 0.64rem;
  background-color: #fff;
}
.check-box {
  width: 0.5333rem;
  height: 0.5333rem;
  border-radius: 50%;
  border: 0.0267rem solid #999;
}
.check-img {
  width: 0.5333rem;
  height: 0.5333rem;
  border-radius: 50%;
}
.active {
  background: #07c160;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  select,
  textarea,
  .el-input/deep/input {
    font-size: 16px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bindChild.vue